<mat-card class="login-card">
  <form [formGroup]="loginForm">
    <mat-card-title style="text-align: center" i18n>
      Login Page
    </mat-card-title>
    <mat-card-subtitle style="text-align: center" i18n
      >Please log in to the system</mat-card-subtitle
    >
    <mat-card-content>
      <div class="flex-col center-center">
        <mat-form-field class="login-input" appearance="outline">
          <input matInput placeholder="email" formControlName="email" />
        </mat-form-field>
        <mat-form-field class="login-input" appearance="outline">
          <input
            type="password"
            matInput
            placeholder="password"
            formControlName="password"
            autocomplete="current-password"
          />
        </mat-form-field>
      </div>
    </mat-card-content>
    <mat-card-actions style="justify-content: center">
      @if ((loading | async) === false) {
      <button
        matButton="elevated"
        type="submit"
        [disabled]="loginForm.invalid"
        color="primary"
        (click)="login()"
      >
        Login
      </button>
      } @if (loading | async) {
      <mat-spinner [diameter]="55" color="accent" />
      }
    </mat-card-actions>
  </form>
</mat-card>
